<template>
  <div class="pa-count-up-text-circle">
    <div class="countup-circle">
      <div class="text" ref="countField">0</div>
    </div>
  </div>
</template>

<script>
import { CountUp } from 'countup.js'

export default {
  props : {
    count : {
      default: null
    },

    couldStartCounting : {
      default: null
    }
  },

  data(){
    return {
      countUpModel  : null,
    };
  },

  watch : {
    count : {
      handler(){
        this.startCounting();
      },
      immediate: true
    },

    couldStartCounting : {
      handler(){
        this.startCounting();
      },
      immediate: true
    }
  },

  methods : {
    async startCounting(){
      if(this.count === null) return;
      if(this.couldStartCounting !== true) return;
      if(typeof this.$refs.countField === 'undefined') return;

      await this.UXWaiting(500);

      this.countUpModel = new CountUp(this.$refs.countField, this.count);

      this.countUpModel.start();
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-count-up-text-circle{
  margin:1.5rem 0;
  .countup-circle{
    border:4px solid #BB9212;
    background-color: #C19306;
    color:#D7C07C;
    font-size:120px;
    width:220px;
    height:220px;
    line-height: 200px;
    border-radius: 50%;
    margin:0 auto;
    vertical-align: middle;
    text-align: center;

    @include until(375px) {
      font-size:100px;
      width:200px;
      height:200px;
      line-height: 180px;
    }
  }
}
</style>